import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getPlant_: () => {
		let url = `${BASE_URL}/cc/v1/plant`;
		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	getCommCds_: ({ plantCd, commCdType }) => {
		let url = `${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${commCdType}`;
		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	getQueueRecordCountList_: ({ plantCd, queueType, remained }) => {
		let url = `${BASE_URL}/queue/v1/plants/${plantCd}/queueCount?queueType=${queueType}&remained=${remained}`;
		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	}
};
